import script from "./LoginMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMain.vue?vue&type=script&setup=true&lang=ts"

import "./LoginMain.vue?vue&type=style&index=0&id=0be2c974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be2c974"]])

export default __exports__